import React, { useMemo } from 'react';
import type { HistoryServiceV3, ServiceConfigurationV1 } from '../feature-service-types';

export type AppContextType = {
  historyService: HistoryServiceV3;
  contentApiConfig: ServiceConfigurationV1;
  isHeadless: boolean;
  oneFootnoteUrls?: string[];
};

export const AppContext = React.createContext<AppContextType>({
  isHeadless: false,
  contentApiConfig: {},
  historyService: null,
  oneFootnoteUrl: '',
} as unknown as AppContextType);

export interface AppContextProviderProps {
  historyService: HistoryServiceV3;
  contentApiConfig: ServiceConfigurationV1;
  isHeadless: boolean;
  oneFootnoteUrls?: string[];
  children?: React.ReactNode;
}

export const AppContextProvider: React.FC<AppContextProviderProps> = (props) => {
  const { children, historyService, oneFootnoteUrls, isHeadless, contentApiConfig } = props;

  const value = useMemo(
    () => ({
      historyService,
      contentApiConfig,
      oneFootnoteUrls,
      isHeadless,
    }),
    [],
  );
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
